import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["strength", "preview", "capacityLabel"];

  connect() {
    this.previousUnit = this.field("quantity_unit").value;
    this.refresh();
  }

  refresh() {
    const unit = this.field("quantity_unit").value;
    const potency = ["mg", "mcg", "IU"].includes(unit);
    const amount = this.field("capacity_quantity");
    const strength = this.field("total_content_amount") || this.field("per_unit_amount");
    if (unit !== this.previousUnit) {
      if (potency && strength) strength.value = "";
      this.previousUnit = unit;
    }
    if (this.hasCapacityLabelTarget)
      this.capacityLabelTarget.textContent = unit === "click" ? "Clicks per pen" : "Amount when full";
    if (this.hasStrengthTarget) this.strengthTarget.hidden = potency;
    if (!this.hasPreviewTarget) return;

    const capacity = Number(amount.value);
    const total = Number(strength.value);
    const each = total / capacity;
    const valid = capacity > 0 && total > 0 && Number.isFinite(each);
    this.previewTarget.hidden = !valid;
    if (valid)
      this.previewTarget.textContent = `Each ${unit} works out to ${Number(each.toFixed(4))} ${this.field("total_content_unit").value}.`;
  }

  field(name) {
    return this.element.elements.namedItem(`supply[${name}]`);
  }
}
